
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import { CommonPageHeading } from '../../../CommonUtilities/CommonHeading/CommonPageHeading';
import { ACADEMIC_YEAR, CONTEXT_NAME, ERROR_MSG } from '../../../CommonUtilities/Validations/RegularExpAndVar';
import Swal from 'sweetalert2';
import Sweetalert, { InfoAlertWithBackTabDisabled } from '../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import moment from 'moment';
import ExamCenters from '../Posts/ExamCenters';
import { examCenterValidations } from '../../../CommonUtilities/Validations/Validations';
import TetPreview from './TetPreview';
import { FaHandPointRight, FaWindowClose } from 'react-icons/fa';
import { RiErrorWarningLine } from "react-icons/ri";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { IoMdCheckboxOutline } from 'react-icons/io';
import { GiTakeMyMoney } from "react-icons/gi";
import { BasicDetails } from '../ChangeMobileNo';

export default function PapersApplication() {
    const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);
    const tabdetails = useSelector((state) => state.reducers.loginreducer.tabdetails);
    //console.log("tabdetails>>", tabdetails)

    let navigate = useNavigate();
    //*************Gets Papers Api *************************** */
    const [showTetPapers, setShowTetPapers] = useState([]);
    const [hideTETSubmit, setHideTETSubmit] = useState(false)
    // function getTetPapers() {
    //     let url = config.url.DSC_Read_URL + "tet-candidate-eligible-papers";
    //     CommonAxiosGet(url).then((res) => {
    //         if (res?.data?.status === true) {
    //             let data = res?.data?.candidateposts?.map((item, index) => {
    //                 // Parse qual_arr string into array of { value, label } for options
    //                 const qualificationOptions = JSON.parse(item.qual_arr || "[]").map((q) => ({
    //                     value: q.qual_id,
    //                     label: q.qual_name,
    //                 }));

    //                 return {
    //                     ...item,
    //                     id: index + 1,
    //                     qualificationOptions, // attach parsed options
    //                 };
    //             }) || [];

    //             // Check if all papers are applied
    //             let filterdata_len = data?.filter((val) => val.is_applied !== false)?.length;
    //             if (filterdata_len === data?.length) {
    //                 setHideTETSubmit(true);
    //             }

    //             //console.log("Parsed TET Papers:", data);
    //             setShowTetPapers(data); // now includes qualificationOptions
    //         } else {
    //             setShowTetPapers([]);
    //         }
    //     });
    // }
    const [showPapersErrMsg, setPapersErrMsg] = useState("");
    function getTetPapers() {
        let url = config.url.DSC_Read_URL + "tet-candidate-eligible-papers";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.status === true) {
                let data = res?.data?.candidateposts?.map((item, index) => ({
                    ...item,
                    id: index + 1
                })) || [];
                let filterdata_len = data?.filter((val) => val.is_applied !== false)?.length
                if (filterdata_len === data?.length) {
                    setHideTETSubmit(true)
                }

                setShowTetPapers(res?.data?.candidateposts);
                setPapersErrMsg("");
            }
            else {
                setShowTetPapers([]);
                setPapersErrMsg("Based On Your Qualifications No Eligible Papers Found");
            }
        }).catch(() => {
            setShowTetPapers([]);
            setPapersErrMsg("Something went wrong. Please try again later.");
        });
    }
    useEffect(() => { getTetPapers(); }, [])

    // *****************resend otp **********************************
    const [showResendTetOtp, setResendTetOtp] = useState(false);
    const [showTetOtpBtn, setTetOtpBtn] = useState(true);
    function sendTetOtp() {
        Swal.fire({
            title: 'Are you Sure Want to Submit?',
            html: `Make Sure , OTP will be Send to your Mobile No. <b style="color: chocolate;">${loginreducer?.mobile_no}</b>`, icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Send OTP",
        }).then((res) => {
            if (res.isConfirmed) {
                let otpUrl = config.url.DSC_URL + "generate-tet-apply-otp"
                CommonAxiosPost(otpUrl).then((rres) => {
                    if (rres?.data?.status === true) {
                        setShowTetOtp(true)
                        setTetOtpBtn(false)
                        setTimer(180);
                        setResendTetOtp(false);
                    }
                    // else if (rres?.data?.scode === '03') {
                    //     Sweetalert(rres?.data?.sdesc, "warning")

                    // }
                    else {
                        Sweetalert(rres?.data?.sdesc, "warning")
                        //Sweetalert('Internal Server Issue', "warning")
                    }

                })
            }
        })
    }
    // ***********timer *******************************
    const [timer, setTimer] = useState(180); // Timer in seconds
    useEffect(() => {
        let interval = null;
        if (!showTetOtpBtn) {
            interval = setInterval(() => {
                setTimer((prevTimer) => {
                    if (prevTimer > 0) {
                        if (prevTimer < 122) {
                            setResendTetOtp(true);
                            return prevTimer - 1;
                        } else if (prevTimer > 1) {
                            return prevTimer - 1;
                        }
                        else {
                            clearInterval(interval);
                            setResendTetOtp(true); // Enable resend button when timer reaches 0
                            return 0;
                        }
                    }
                });
            }, 1000);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [showTetOtpBtn]);

    const formatTime = (timeInSeconds) => {
        if (isNaN(timeInSeconds) || timeInSeconds < 0) {
            return "0:00";
        }
        const minutes = Math.floor(timeInSeconds / 60);
        const seconds = timeInSeconds % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };
    const resendTetOTP = () => {
        Formik.setFieldValue("otp", "")
        sendTetOtp()

    };
    //******************validations **************************
    let userValidations = Yup.object().shape({
        paperDetails: Yup.array()
            .of(
                Yup.object().shape({
                    tetPaperId: Yup.string().required("Paper is required"),
                })
            )
            .min(1, "Please select at least one paper"),
        ...examCenterValidations.fields,
        papersSelfCheck1: Yup.boolean().oneOf([true], ERROR_MSG).nullable(),
        papersSelfCheck2: Yup.boolean().oneOf([true], ERROR_MSG).nullable(),
    })
    // ***********************formik **************************
    const Formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            payment: 0,
            paperDetails: [],
            option1: "",
            option2: "",
            option3: "",
            option4: "",
            option5: "",
            otp: '',
            papersSelfCheck1: false,
            papersSelfCheck2: false,
        },
        validationSchema: userValidations,
        onSubmit: (values) => {
            // ✅ 1. Check if any paper is missing a language
            const invalidPaper = values.paperDetails.find(
                (p) => !p.mediumId || p.mediumId.trim() === ""
            );
            if (invalidPaper) {
                const paperName =
                    showTetPapers.find((p) => p.tet_paper_id === invalidPaper.tetPaperId)
                        ?.tet_paper_name || "Selected paper";

                InfoAlertWithBackTabDisabled(
                    `Please select a language for ${paperName}`,
                    "error"
                );
                return; // Stop submission
            }

            const invalidSanskrit = values.paperDetails.find(
                (p) =>
                    ["paper_1_a", "paper_1_b"].includes(p.tetPaperId) &&
                    p.mediumId === "8"
            );
            if (invalidSanskrit) {
                const paperName =
                    showTetPapers.find(
                        (p) => p.tet_paper_id === invalidSanskrit.tetPaperId
                    )?.tet_paper_name || "Selected paper";

                InfoAlertWithBackTabDisabled(
                    `SANSKRIT is not allowed for ${paperName}. Please choose another medium.`,
                    "error"
                );
                return;
            }

            // const invalidQualification = values.paperDetails.find(
            //     (p) => !p.qualId || p.qualId.trim() === ""
            // );
            // if (invalidQualification) {
            //     const paperName =
            //         showTetPapers.find(
            //             (p) => p.tet_paper_id === invalidQualification.tetPaperId
            //         )?.tet_paper_name || "Selected paper";

            //     InfoAlertWithBackTabDisabled(
            //         `Please select a qualification for ${paperName}.`,
            //         "error"
            //     );
            //     return; // Stop submission
            // }

            sendTetOtp();
        }
    })
    // *************papers amount logic **********************
    const [selectedPapersCount, setSelectedPapersCount] = useState(0);
    const [previousPostCount, setPreviousPostCount] = useState(0);
    const [AlPaidPostCount, setAlPaidPost] = useState(0)
    function PreviousCountFunction() {
        let linkurl = config.url.DSC_URL + 'tet-candidate-balance-posts'
        CommonAxiosGet(linkurl).then((response) => {
            if (response?.data.status === true) {
                setAlPaidPost(response?.data?.data[0]?.alr_paid_posts);
                setPreviousPostCount(response?.data?.data[0]?.balance_pay)
            }
            else {
                setAlPaidPost(0);
                setPreviousPostCount(0);
            }
        })
    }
    useEffect(() => {

        // console.log("cc>>", Formik?.values?.paperDetails)
        const count = Formik?.values?.paperDetails?.filter((val) => val?.tetPaperId !== "").length || 0;
        if (count > 0) {
            setSelectedPapersCount(count);
            let amount = (count - parseInt(previousPostCount)) * 1000
            Formik.setFieldValue('payment', amount > 0 ? amount : 0)
        }
        else {
            setSelectedPapersCount(0)
        }

    }, [Formik?.values])


    // ******************post api ****************************

    const [showTetOtp, setShowTetOtp] = useState(false)
    async function postTetDataFun() {
        const values = Formik?.values;

        const eligiblePapers = values.paperDetails.filter(paper => {
            const matched = showTetPapers.find(sp => sp.tet_paper_id === paper.tetPaperId);
            return !matched?.is_applied; // include only papers not already applied
        });

        if (eligiblePapers?.length === 0) {
            Sweetalert("You have already applied for all selected papers. Please select new papers to continue.", "warning");
            return;
        }

        const postValues = {
            payment: values?.payment,
            paperDetails: eligiblePapers,
            option1: values?.option1,
            option2: values?.option2,
            option3: values?.option3,
            option4: values?.option4,
            option5: values?.option5,
            otp: values?.otp,
        };
        // console.log("vv>>", postValues)
        if (showTetOtp === true && values?.otp !== "") {
            const url = config.url.DSC_URL + "tet-candidate-paper-details";

            Swal.fire({
                title: "Are you Sure?",
                html: `You have selected <b style="color: blue;">${postValues?.paperDetails?.length}</b> paper(s)
            ${postValues?.payment > 0 ? `${previousPostCount > 0 ? `,<br/>You have already paid for<b style="color: blue;"> ${previousPostCount} </b>paper(s)` : ''}<br/>
            Now you need to pay <b style="color: green;">${postValues?.payment} Rs.</b> for
            <b style="color: blue;">${postValues?.paperDetails?.length - previousPostCount} </b> paper(s)` : ""}`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: postValues?.payment > 0 ? "Proceed to Pay" : "Submit",
            }).then(async (res) => {
                if (res.isConfirmed) {
                    try {
                        const response = await CommonAxiosPost(url, postValues);

                        if (response?.data?.status === true) {
                            getExamDataFunction();

                            if (postValues?.payment > 0) {
                                const link = response?.data?.paymentUrl;
                                window.open(link, "_self");
                            } else {
                                Swal.fire({
                                    title: "Successfully Submitted",
                                    icon: "success",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    confirmButtonText: "OK",
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        navigate("/TetPrintApplication");
                                        window.location.reload();
                                    } else if (res.dismiss === Swal.DismissReason.cancel) {
                                        window.location.reload();
                                    }
                                });
                            }
                        } else {
                            Sweetalert(response?.data?.sdesc, "error");
                            Formik.setFieldValue("otp", "");
                        }
                    } catch (error) {
                        console.error("Error while posting data:", error);
                        Sweetalert("Something went wrong while submitting.", "error");
                        Formik.setFieldValue("otp", "");
                    }
                }
            });
        } else {
            Sweetalert("Please Enter OTP to continue", "warning");
        }
    }


    // ****************************paper-I-A and Paper-I-B logic ---------------------------------
    const [examCenterData, setExamCenterData] = useState([])
    const getExamDataFunction = () => {
        let examsUrl = config.url.DSC_Read_URL + "candidate-exam-center-details";
        CommonAxiosGet(examsUrl).then((response) => {
            if (response?.data.status === true) {
                let data = response.data.data
                setExamCenterData(response.data.data)
                Formik?.setFieldValue('option1', data[0]?.dist_code)
                Formik?.setFieldValue('option2', data[1]?.dist_code)
                Formik?.setFieldValue('option3', data[2]?.dist_code)
                Formik?.setFieldValue('option4', data[3]?.dist_code)
                Formik?.setFieldValue('option5', data[4]?.dist_code)

            }
            else {
                setExamCenterData([])
            }
        });
    };
    // const [tetExamCenters, setTetExamCenters] = useState()
    // const getTetExamCentersFun = () => {
    //     let url = config.url.DSC_Read_URL + "exam-centers";
    //     CommonAxiosGet(url).then((res) => {
    //         if (res?.data?.status === true) {
    //             setTetExamCenters(res?.data?.examcenters)
    //         }
    //         else {
    //             setTetExamCenters([])
    //         }
    //     });
    // };

    useEffect(() => {
        getExamDataFunction();
        PreviousCountFunction();
    }, [])
    const handleClose = () => setShow(false);
    const [show, setShow] = useState(() => {
        if (tabdetails?.latestTab === 3) {
            return tabdetails?.confirm === false;
        }
        return '';
    });
    const points = [
        "I hereby declare that I have read and understood the notification, and that all the information provided above is true and correct to the best of my knowledge.",
        "English is compulsory language as Language-II. The total question paper shall be in Language-I (selected in papers details) followed by English (Language-II)."
    ];
    return (
        <React.Fragment>
            <div className='pop pop-fix'>
                {show && <div className="background-hide"></div>}
                <Modal size="xl" className='pop pop-fix' show={show} onHide={() => { handleClose(); navigate(-1) }} backdrop="static"
                    style={{ maxWidth: '100%', width: '100%' }}
                >
                    <Modal.Header style={{}} >
                        <Modal.Title>  {CONTEXT_NAME}</Modal.Title>
                        <button type="button" className='btn btn-end'
                            onClick={() => {
                                setShow(false);
                                navigate(-1)
                            }} style={{ fadeType: "out" }}
                            variant="danger"
                            aria-label="Close"><h4>
                                <FaWindowClose className="text-danger" size={32} />
                            </h4></button>
                    </Modal.Header>
                    <Modal.Body>
                        <TetPreview handleClose={handleClose} />
                    </Modal.Body>
                </Modal></div>
            <CommonPageHeading heading={`${CONTEXT_NAME} ${ACADEMIC_YEAR} Paper Details`} />
            {tabdetails?.confirm ? <>
                {showPapersErrMsg ? <div className="text-center text-danger fw-bold mt-3">
                    {showPapersErrMsg}
                </div> : (<>
                   <BasicDetails loginreducer = {loginreducer}/>

                    <FormikProvider value={Formik}>
                        <Form className="form-section" onSubmit={Formik.handleSubmit}>
                            <div className='px-4 mt-4'>

                                <div className="personal-head ">
                                    <span>Papers Details</span>
                                </div>
                                <div className="personal-row pb-3">
                                    <Row className="px-3">
                                        <div className="table-responsive">
                                            <div className='px-4 mt-4'>
                                                <Row>

                                                    <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={2} className=''>
                                                        <div className='mb-2'>
                                                            <FaHandPointRight size={30} />&emsp;

                                                            <OverlayTrigger placement="top-start"
                                                                overlay={
                                                                    <Tooltip id="note-tooltip" className="custom-tooltip">
                                                                        <strong>1. How to choose language–I of APTET Paper-I:</strong><br />
                                                                        The following languages are offered under First Language in the Schools under the State Syllabus viz.,
                                                                        Telugu, Urdu, Hindi, Kannada, Tamil and Odiya. A candidate has to choose one of these six (6) languages under
                                                                        Language-I for AP TET; those candidates shall have compulsorily studied that language either as medium of study
                                                                        or as First Language up to class X.<br />
                                                                        <strong>2. English is compulsory language for all candidates as Language-II.</strong>
                                                                    </Tooltip>
                                                                }
                                                                popperConfig={{
                                                                    modifiers: [
                                                                        {
                                                                            name: 'offset',
                                                                            options: {
                                                                                offset: [50, 5] // [skewRight, down], adjust numbers as needed
                                                                            },
                                                                        },
                                                                    ],
                                                                }}
                                                            >
                                                                <i
                                                                    style={{ background: "#2a9d8f", cursor: "pointer" }}
                                                                    className="badge badge-success forgot fw-bold"
                                                                >
                                                                    Read Me <RiErrorWarningLine style={{ fontSize: '22px' }} />
                                                                </i>
                                                            </OverlayTrigger>

                                                        </div>
                                                    </Col>

                                                    <Col xxl={10} xl={10} lg={10} md={10} sm={12} xs={12}>

                                                        <div className='alert alert-info'>
                                                            <h6> <span style={{ fontFamily: 'bold' }} className='text-danger'>NOTE : </span>
                                                                <ul>
                                                                    <li>
                                                                        It is highly recommended to complete payments using a <strong>laptop or desktop</strong>, as mobile devices may experience technical issues during the process.
                                                                    </li>
                                                                    {AlPaidPostCount > 0 && (<li>
                                                                        You have made payment for&nbsp;
                                                                        <span style={{ color: 'red', fontFamily: 'bold' }}>{AlPaidPostCount}</span> no. of paper(s) earlier,please select below
                                                                        eligible paper(s).
                                                                    </li>)}
                                                                </ul>
                                                            </h6>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>

                                            {(() => {
                                                if (showPapersErrMsg) {
                                                    return (
                                                        <div className="text-center text-danger fw-bold mt-3">
                                                            {showPapersErrMsg}
                                                        </div>
                                                    );
                                                }
                                                // Split papers into 2 groups dynamically
                                                let table1 = [];
                                                let table2 = [];

                                                if (showTetPapers.length === 2) {
                                                    table1 = [showTetPapers[0]];
                                                    table2 = [showTetPapers[1]];
                                                } else if (showTetPapers.length === 3) {
                                                    table1 = [showTetPapers[0], showTetPapers[2]];
                                                    table2 = [showTetPapers[1]];
                                                } else if (showTetPapers.length > 3) {
                                                    // Alternate splitting for more than 3 papers
                                                    showTetPapers.forEach((paper, index) => {
                                                        if (index % 2 === 0) table1.push(paper);
                                                        else table2.push(paper);
                                                    });
                                                } else {
                                                    table1 = [...showTetPapers];
                                                }

                                                // Helper to render a table
                                                const renderTable = (papers, tableIndex) => (
                                                    <table
                                                        key={tableIndex}
                                                        className="table table-condensed table-bordered mb-3"
                                                        style={{ borderCollapse: "collapse", width: "48%" }}
                                                    >
                                                        <thead className="tetpapers-table-head">
                                                            <tr>
                                                                <th>Choose Paper</th>
                                                                <th>Language 1</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="tetpapers-table fw-sm">
                                                            {papers.map((paper) => {
                                                                const isChecked = Formik.values.paperDetails.some(
                                                                    (p) => p.tetPaperId === paper.tet_paper_id
                                                                );

                                                                const currentMedium =
                                                                    Formik.values.paperDetails.find(
                                                                        (p) => p.tetPaperId === paper.tet_paper_id
                                                                    )?.mediumId || "";

                                                                return (
                                                                    <tr key={paper.tet_paper_id}>
                                                                        <td style={{ width: "80%", fontSize: "0.85rem", lineHeight: "1.3" }}>
                                                                            {paper.is_applied ? (
                                                                                <span className="d-flex align-items-center gap-2">
                                                                                    <IoMdCheckboxOutline color="green" size={20} />
                                                                                    <span style={{ fontWeight: 550 }}>{paper.tet_paper_name}</span>
                                                                                </span>
                                                                            ) : (
                                                                                <Form.Check
                                                                                    type="checkbox"
                                                                                    id={paper.tet_paper_id}
                                                                                    label={<span style={{ fontWeight: 550 }}>{paper.tet_paper_name}</span>}
                                                                                    checked={isChecked}
                                                                                    onChange={(e) => {
                                                                                        if (paper.is_applied) return;
                                                                                        let updated = [...Formik.values.paperDetails];
                                                                                        if (e.target.checked) {
                                                                                            updated.push({
                                                                                                tetPaperId: paper.tet_paper_id,
                                                                                                mediumId: "",
                                                                                                qualId: "",
                                                                                            });
                                                                                        } else {
                                                                                            updated = updated.filter(
                                                                                                (p) => p.tetPaperId !== paper.tet_paper_id
                                                                                            );
                                                                                        }
                                                                                        Formik.setFieldValue("paperDetails", updated);
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        </td>

                                                                        <td style={{ width: "20%", fontSize: "0.90rem" }}>
                                                                            {paper.is_applied ? (
                                                                                <span>{paper?.medium}</span>
                                                                            ) : (
                                                                                isChecked && (
                                                                                    <Form.Select
                                                                                        value={currentMedium}
                                                                                        className="form-control form-control-sm"
                                                                                        onChange={(e) => {
                                                                                            const updated = Formik.values.paperDetails.map((p) =>
                                                                                                p.tetPaperId === paper.tet_paper_id
                                                                                                    ? { ...p, mediumId: e.target.value }
                                                                                                    : p
                                                                                            );
                                                                                            Formik.setFieldValue("paperDetails", updated);
                                                                                        }}
                                                                                    >
                                                                                        <option value="">--Select--</option>
                                                                                        <option value="1">TELUGU</option>
                                                                                        <option value="2">URDU</option>
                                                                                        <option value="3">HINDI</option>
                                                                                        <option value="4">KANNADA</option>
                                                                                        <option value="5">ORIYA</option>
                                                                                        <option value="6">TAMIL</option>
                                                                                        {(paper.tet_paper_id !== "paper_1_a" &&
                                                                                            paper.tet_paper_id !== "paper_1_b") && (
                                                                                                <option value="8">SANSKRIT</option>
                                                                                            )}
                                                                                    </Form.Select>
                                                                                )
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                );

                                                return (
                                                    <div className="d-flex gap-3 flex-wrap justify-content-start">
                                                        {table1.length > 0 && renderTable(table1, 1)}
                                                        {table2.length > 0 && renderTable(table2, 2)}
                                                    </div>
                                                );
                                            })()}
                                            {selectedPapersCount > 0 &&
                                                <Row><Col md={12} className='text-center'>
                                                    <div className='alert alert-success'>
                                                        {(previousPostCount > 0 && (parseInt(AlPaidPostCount) - parseInt(previousPostCount) > 0)) ?
                                                            <> You have already applied for {AlPaidPostCount - previousPostCount} paper(s).&nbsp;</>
                                                            : ''}
                                                        {selectedPapersCount > 0 && (<> you are now applying for {selectedPapersCount}&nbsp;paper(s)<span style={{ color: "green" }}>
                                                            &nbsp; ({parseInt(selectedPapersCount) * 1000} Rs.) </span>
                                                        </>)}
                                                        <pre />
                                                        {(parseInt(selectedPapersCount) - parseInt(previousPostCount)) > 0 ? (<>
                                                            You have to Pay an amount of  <span style={{ color: "green" }}>&nbsp;
                                                                {(parseInt(selectedPapersCount) - parseInt(previousPostCount)) * 1000} Rs. </span> &nbsp;
                                                            <span className='blink-color'
                                                            > PAYMENT</span>

                                                        </>) :
                                                            (<>
                                                                {(parseInt(previousPostCount) - parseInt(selectedPapersCount)) > 0 && (<>
                                                                    Balance Amount   : <span style={{ color: "green" }}>&nbsp;
                                                                        {(parseInt(previousPostCount) - parseInt(selectedPapersCount)) * 1000}  Rs.</span> &nbsp;
                                                                </>)}
                                                            </>)

                                                        }

                                                    </div>
                                                </Col></Row>}

                                            {/* <table className="table table-condensed choose-paper-table"
                                            style={{ borderCollapse: "collapse", width: showTetPapers.length === 1 ? "50%" : "100%", }}
                                        >
                                            <thead>
                                                <tr>
                                                    {Array.from({ length: Math.min(2, showTetPapers.length) }).map((_, index) => (
                                                        <React.Fragment key={index}>
                                                            {index > 0 && <th className="spacer-th"></th>}
                                                            <th className={index === 0 ? "tetpaperscol1" : "tetpaperscol2"} > Choose Paper </th>
                                                            <th className={index === 0 ? "tetpaperscol1" : "tetpaperscol2"} > Language 1 </th>
                                                        </React.Fragment>
                                                    ))}
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {Array.from({ length: Math.ceil(showTetPapers.length / 2) }).map((_, rowIndex) => (
                                                    <tr key={rowIndex}>
                                                        {showTetPapers.slice(rowIndex * 2, rowIndex * 2 + 2).map((paper, index) => {
                                                            const isChecked = Formik.values.paperDetails.some(
                                                                (p) => p.tetPaperId === paper.tet_paper_id
                                                            );
                                                            const currentMedium =
                                                                Formik.values.paperDetails.find(
                                                                    (p) => p.tetPaperId === paper.tet_paper_id
                                                                )?.mediumId || "";
                                                            return (
                                                                <React.Fragment key={paper.tet_paper_id}>
                                                                    {index > 0 && <td className="spacer-td"></td>}
                                                                    <td className={index === 0 ? "tetpaperscol1" : "tetpaperscol2"}
                                                                        style={{ width: "35%", }}
                                                                    >
                                                                        {paper.is_applied ? (<span className="d-flex align-items-center gap-2">
                                                                            <IoMdCheckboxOutline color="green" size={20} />
                                                                            <span >{paper.tet_paper_name}</span>
                                                                        </span>) :
                                                                            <Form.Check type="checkbox" id={paper.tet_paper_id}
                                                                                label={paper.tet_paper_name}
                                                                                checked={isChecked}
                                                                                onChange={(e) => {
                                                                                    if (paper.is_applied) return;
                                                                                    let updated = [...Formik.values.paperDetails];
                                                                                    if (e.target.checked) {
                                                                                        updated.push({
                                                                                            tetPaperId: paper.tet_paper_id,
                                                                                            mediumId: "",
                                                                                        });
                                                                                    } else {
                                                                                        updated = updated.filter(
                                                                                            (p) => p.tetPaperId !== paper.tet_paper_id
                                                                                        );
                                                                                    }
                                                                                    Formik.setFieldValue("paperDetails", updated);
                                                                                }}
                                                                            />
                                                                        }
                                                                    </td>
                                                                    <td
                                                                        className={index === 0 ? "tetpaperscol1" : "tetpaperscol2"}
                                                                        style={{ padding: "10px", verticalAlign: "top", width: "15%" }}
                                                                    >
                                                                        {paper.is_applied ? (
                                                                            <span className="d-flex align-items-center gap-2">
                                                                                <span> {paper?.medium}</span>
                                                                            </span>
                                                                        ) : (
                                                                            isChecked && (
                                                                                <Form.Select
                                                                                    value={currentMedium}
                                                                                    className='form-control form-control-sm'
                                                                                    onChange={(e) => {
                                                                                        const updated = Formik.values.paperDetails.map((p) =>
                                                                                            p.tetPaperId === paper.tet_paper_id
                                                                                                ? { ...p, mediumId: e.target.value }
                                                                                                : p
                                                                                        );
                                                                                        Formik.setFieldValue("paperDetails", updated);
                                                                                    }}
                                                                                >
                                                                                    <option value="">--Select--</option>
                                                                                    <option value="1">TELUGU</option>
                                                                                    <option value="2">URDU</option>
                                                                                    <option value="3">HINDI</option>
                                                                                    <option value="4">KANNADA</option>
                                                                                    <option value="5">ORIYA</option>
                                                                                    <option value="6">TAMIL</option>
                                                                                    {(paper.tet_paper_id !== "paper_1_a" && paper.tet_paper_id !== "paper_1_b") && (
                                                                                        <option value="8">SANSKRIT</option>
                                                                                    )}
                                                                                </Form.Select>
                                                                            )
                                                                        )}
                                                                    </td>
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table> */}
                                        </div>
                                        <ErrorMessage name="paperDetails" component="div" className="text-error" />
                                    </Row>
                                </div>

                                <ExamCenters Formik={Formik} Data={examCenterData} />

                                <Row className="pb-0 pt-2 mx-0">
                                    <Col xs={12} className="alert alert-warning">
                                        {points.map((text, index) => {
                                            const fieldName = `papersSelfCheck${index + 1}`;
                                            return (
                                                <div key={index} className={`${index > 0 ? 'mt-2' : ''}`}>
                                                    <div className="d-flex align-items-center">
                                                        {!hideTETSubmit ? (
                                                            <Field type="checkbox" name={fieldName} className="form-sub me-2"
                                                                onChange={(e) => {
                                                                    const isChecked = e.target.checked;
                                                                    Formik.setFieldValue(fieldName, isChecked ? true : null);
                                                                }}
                                                            />
                                                        ) : (
                                                            <IoMdCheckboxOutline color="green" size={20} className="me-2" />
                                                        )}
                                                        <span>{text}</span>
                                                    </div>

                                                    {!hideTETSubmit && (
                                                        <ErrorMessage name={fieldName} component="div" className="text-error mt-1" />
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </Col>
                                </Row>
                                {hideTETSubmit === false &&
                                    <Row className='pb-4'>
                                        {showTetOtp === true &&
                                            <React.Fragment>
                                                <Col xs={3} sm={3} md={3} lg={3} xl={3} xxl={3}></Col>
                                                <Col xs={3} sm={3} md={3} lg={3} xl={3} xxl={3} className='pt-2 mt-4'>
                                                    {showResendTetOtp === true ? <React.Fragment>
                                                        <Form.Label className="input-lable mt-2">Didn't receive code? </Form.Label>&emsp;
                                                        <Button variant="primary" type="button" className="" onClick={() => { resendTetOTP() }}>Resend OTP </Button>
                                                    </React.Fragment>
                                                        : ''}
                                                </Col>
                                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className='pt-2 mt-4'>
                                                    <React.Fragment>
                                                        <p>
                                                            Time Remaining:  {formatTime(timer)}
                                                        </p>
                                                    </React.Fragment>
                                                </Col>
                                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className='pt-2 mt-4'>
                                                    <Form.Group controlId="otp">
                                                        <Field type="text" name="otp" className="input-field form-control" placeholder="Enter OTP" maxLength={6} />
                                                    </Form.Group>
                                                </Col>
                                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className='pt-2 mt-4'>
                                                    <div className='float-end'>
                                                        <Button variant="success" type="button" className="submit-btn btn-success"
                                                            onClick={() => { postTetDataFun() }}
                                                        >
                                                            {Formik?.values?.payment > 0 ? 'Proceed to Pay & Submit' : 'Submit'}
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </React.Fragment>}
                                        {showTetOtp === false && <React.Fragment>
                                            <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}></Col>
                                            <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className='pt-2 mt-2'>
                                                <div className='float-end'><Button variant="primary" type="submit" className="submit-btn btn-primary">  Generate OTP </Button></div>
                                            </Col>
                                        </React.Fragment>}
                                    </Row>
                                }


                            </div>
                        </Form>
                    </FormikProvider>
                </>)}
            </> :
                <div>   <h3 className="text-error mt-4 border p-3 fs-6 w-100">
                    <strong>Dear {loginreducer?.applicant_name},</strong><pre />
                    Your Application is Partially Submitted for {CONTEXT_NAME}-{ACADEMIC_YEAR} , Please Complete the Application to View Papers.
                    <span>  <i style={{ background: "#2a9d8f" }}
                        className="badge badge-success forgot fw-bold"
                        onClick={() => navigate('/ProfileDetailsWay')}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                navigate('/ProfileDetailsWay')
                            }
                        }}
                        data-toggle="tooltip" animation="true"
                    > Click Here </i> </span> to complete the application.

                </h3></div>}
        </React.Fragment>
    )
}
